<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Store",
};
</script>

<style lang="scss" scoped></style>
